import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Action from "../Action/Action";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.refresh();

const Franchise = (props) => {
  const windowWidth = window.innerWidth;

  useEffect(() => {
    if (windowWidth >= 1024) {
      gsap.to(".bs-shop--product", {
        duration: 3,
        opacity: 1,
        translateX: "60px",
        scrollTrigger: {
          trigger: ".bs-shop",
          start: "-=500px"
          // markers: true,
        }
      });
      gsap.to(".bs-shop--text_content", {
        duration: 3,
        opacity: 1,
        translateX: "-10%",
        scrollTrigger: {
          trigger: ".bs-shop",
          start: "-=500px"
          // markers: true,
        }
      });
    } else {
      gsap.to(".bs-shop--product", {
        duration: 3,
        opacity: 1,
        marginLeft: 0,
        scrollTrigger: {
          trigger: ".bs-shop",
          start: "-=500px"
          // markers: true,
        }
      });
      gsap.to(".bs-shop--text_content", {
        duration: 3,
        opacity: 1,
        translateX: "0",
        scrollTrigger: {
          trigger: ".bs-shop",
          start: "-=500px"
          // markers: true,
        }
      });
    }
  }, [windowWidth]);

  return (
    <div id="franchise" className="bs-franchise">
      <h2 className="bs-section--heading large">Franchise Opportunities</h2>

      <div className="bs-split" data-direction="left">
        <div
          className="bs-split--poster"
          data-section="phase1"
          data-direction="left"
        ></div>
        <div className="bs-split--text" data-direction="left">
          <h2 className="bs-split--text_label">Southern California</h2>
          <h3 className="bs-split--text_heading">
            Available Territories for Franchise
          </h3>
        </div>
      </div>

      <div className="bs-split" data-direction="right">
        <div
          className="bs-split--poster"
          data-section="phase2"
          data-direction="right"
        ></div>
        <div className="bs-split--text" data-direction="right">
          <h2 className="bs-split--text_label">Southern States</h2>
          <h3 className="bs-split--text_heading">
            Available Territories for Franchise
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Franchise;
